import React, { useEffect, useRef } from "react";

// Official TradingView Advanced Chart widget (tv.js). Users can add built-in
// indicators via the "Indicators" button. Community/invite-only Pine scripts
// (LuxAlgo etc.) cannot be injected here — they work only on tradingview.com.
export default function TradingViewChart({ symbol = "OANDA:XAUUSD", interval = "15", height = 560, studies = [] }) {
  const ref = useRef(null);

  useEffect(() => {
    const container = ref.current;
    if (!container) return;
    container.innerHTML = "";
    const widgetDiv = document.createElement("div");
    widgetDiv.id = "tv_" + Math.random().toString(36).slice(2);
    widgetDiv.style.height = "100%";
    widgetDiv.style.width = "100%";
    container.appendChild(widgetDiv);

    const cleanStudies = (studies || []).filter(Boolean);

    const build = () => {
      if (!window.TradingView) return;
      /* eslint-disable no-new */
      new window.TradingView.widget({
        autosize: true,
        symbol,
        interval,
        timezone: "Europe/Warsaw",
        theme: "dark",
        style: "1",
        locale: "pl",
        toolbar_bg: "#0c0a12",
        enable_publishing: false,
        allow_symbol_change: true,
        hide_side_toolbar: false,
        withdateranges: true,
        details: true,
        container_id: widgetDiv.id,
        studies: cleanStudies.length ? cleanStudies : undefined,
      });
    };

    if (window.TradingView) {
      build();
    } else {
      const existing = document.getElementById("tradingview-tvjs");
      if (existing) {
        existing.addEventListener("load", build);
      } else {
        const s = document.createElement("script");
        s.id = "tradingview-tvjs";
        s.src = "https://s3.tradingview.com/tv.js";
        s.async = true;
        s.onload = build;
        document.body.appendChild(s);
      }
    }
  }, [symbol, interval, JSON.stringify(studies)]);

  return (
    <div
      ref={ref}
      data-testid="tradingview-chart"
      style={{ height }}
      className="w-full rounded-xl overflow-hidden border border-violet-900/40 bg-black/40"
    />
  );
}
